<template lang="pug">
yz-filter-menu(:label="$t('panel.invoice_number')" :is-active="isActive" :display-value="displayValue" :disable-apply="!invoiceNumber || invoiceNumber.trim() === ''" @clear="onClear" @apply="onApply")
  .pa-4
    yz-text-field(v-model="invoiceNumber" :label="$t('panel.invoice_number')" :placeholder="$t('panel.enter_invoice_number')" size="lg")
</template>

<script>
export default {
  props: {
    filter: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      invoiceNumber: '',
      isActive: false,
      displayValue: ''
    }
  },
  methods: {
    onClear() {
      this.invoiceNumber = ''
      this.isActive = false
      this.displayValue = ''
      this.$emit('update:filter', {})
    },
    onApply() {
      this.isActive = true
      this.displayValue = this.invoiceNumber

      this.$emit('update:filter', {
        key: 'rid',
        value: this.invoiceNumber.trim()
      })
    },
    reset() {
      this.onClear()
    },
    restoreFromParams(params) {
      // Restore filter state from URL params
      if (params.rid) {
        this.invoiceNumber = params.rid
        this.onApply()
      }
    }
  }
}
</script>
